module.exports = __webpack_public_path__ + "img/giphy.f5a107be.gif";